/**
 * Badge « ✓ Prénom » (vert) à la position de la carte, au moment où elle est
 * comptée : le retour qui dit au prof qu'il peut avancer. La liste est pilotée
 * par ScanMobile (ajout au scan validé, retrait après ~1,2 s, durée de
 * l'animation scan-badge). Plus de « déjà pris » : une carte déjà comptée
 * garde son contour vert, ça suffit.
 */
const DetectionBadges = ({ badges }) => (
  <div className="absolute inset-0 pointer-events-none z-[5]" aria-hidden="true">
    {badges.map((b) => (
      <span key={b.id} className="scan-badge" style={{ left: b.x, top: b.y }}>
        ✓ {b.nom}
      </span>
    ))}
  </div>
);

export default DetectionBadges;
